import React from 'react';
import SEOHead from '../SEOHead';
import { Card, CardContent } from '../ui/card';

const AboutMePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Exlo",
    "jobTitle": "AI-Assisted Music Producer and Digital Artist",
    "description": "Tech-savvy wordsmith creating emotional electronic music with AI assistance. Read about Exlo's musical journey and creative process.",
    "url": "https://music.exlo.no/about-me",
    "sameAs": [
      "https://x.com/TeAmExlo",
      "https://www.facebook.com/exlo84",
      "https://www.instagram.com/exlo_84/",
      "https://open.spotify.com/artist/0LLP1veWAmGmNZ3mxAZvPF",
      "https://www.youtube.com/@ExloMusicNO",
      "https://soundcloud.com/exlo-exlo-177213603",
      "https://exlomusic.medium.com/"
    ],
    "knowsAbout": [
      "Electronic Music Production",
      "AI-Assisted Music Creation",
      "Digital Music Technology",
      "Songwriting",
      "Audio Engineering"
    ],
    "genre": ["Electronic", "AI-Assisted Music", "Digital Music"]
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white">
      <SEOHead
        title="About Exlo - AI-Assisted Music Producer and Digital Artist"
        description="Tech-savvy wordsmith creating emotional electronic music with AI assistance. Read about Exlo's musical journey and creative process."
        url="/about-me"
        structuredData={structuredData}
      />
      
      <noscript>
        <div className="p-8">
          <h1 className="text-3xl font-bold mb-4 text-[#e94560]">About Exlo</h1>
          <p className="text-lg mb-4">Tech-savvy wordsmith who can't carry a tune? That's me.</p>
          <p className="text-lg mb-4">Luckily, I've found a way to merge my love for the latest tech with my overflowing lyric notebook. AI helps me bring those lyrics to life in ways I never thought possible.</p>
          <p className="text-lg">More in-depth info about both Exlo the artist, and a deeper dive into the songs can be read in the Medium posts: <a href="https://exlomusic.medium.com/" className="text-cyan-400 underline">https://exlomusic.medium.com/</a></p>
        </div>
      </noscript>

      <div className="p-4 md:p-8 max-w-4xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-[#e94560]">About Exlo</h1>
          <p className="text-lg text-gray-300">Tech-savvy wordsmith creating emotional electronic music with AI assistance.</p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <Card className="bg-transparent border-[#e94560]">
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold mb-4 text-[#e94560]">The Artist</h2>
              <p className="text-white text-lg font-light leading-relaxed mb-4">
                Tech-savvy wordsmith who can't carry a tune? That's me.
              </p>
              <p className="text-white text-lg font-light leading-relaxed">
                Luckily, I've found a way to merge my love for the latest tech with my overflowing lyric notebook. AI helps me bring those lyrics to life in ways I never thought possible.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-transparent border-[#e94560]">
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold mb-4 text-[#e94560]">The Process</h2>
              <p className="text-white text-lg font-light leading-relaxed mb-4">
                Creating music with AI assistance allows me to focus on what I do best - crafting meaningful lyrics and emotional narratives.
              </p>
              <p className="text-white text-lg font-light leading-relaxed">
                Each song begins with a story, a feeling, or an experience that needs to be shared. Technology helps transform these words into compelling electronic soundscapes.
              </p>
            </CardContent>
          </Card>
        </div>

        <Card className="bg-transparent border-[#e94560] mt-8">
          <CardContent className="p-6">
            <h2 className="text-2xl font-bold mb-4 text-[#e94560]">Learn More</h2>
            <p className="text-white text-lg font-light leading-relaxed">
              More in-depth info about both Exlo the artist, and a deeper dive into the songs can be read in the Medium posts: 
              <a href="https://exlomusic.medium.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-400 underline hover:text-cyan-300 transition-colors ml-2">
                https://exlomusic.medium.com/
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AboutMePage;
